// Translates raw Supabase auth rejections into friendlier copy.
//
// IMPORTANT: the breached-password case is detected by MESSAGE TEXT ONLY.
// Supabase reuses the `weak_password` error code for ordinary policy failures
// (missing digit, too short, etc.), so keying off the code would tell users
// their password appeared in a data breach when it simply failed a rule.
// Anything that doesn't match the breach phrasing falls through unchanged.

const BREACH_PHRASES = ["known to be weak", "pwned", "data breach"];

export const BREACHED_PASSWORD_MESSAGE =
  "That password shows up in known data breaches. Please choose a different one.";

export function isBreachedPasswordError(error: unknown): boolean {
  const message =
    typeof error === "string"
      ? error
      : ((error as { message?: unknown } | null)?.message as string | undefined) ?? "";
  const lower = message.toLowerCase();
  return BREACH_PHRASES.some((phrase) => lower.includes(phrase));
}

/**
 * Returns friendly copy for breached-password rejections, otherwise the
 * original message untouched.
 */
export function friendlyPasswordError(error: unknown, fallbackMessage?: string): string {
  if (isBreachedPasswordError(error)) return BREACHED_PASSWORD_MESSAGE;
  if (fallbackMessage !== undefined) return fallbackMessage;
  if (typeof error === "string") return error;
  return ((error as { message?: unknown } | null)?.message as string | undefined) ?? "Something went wrong";
}
